import { visit } from 'unist-util-visit';

import type { Root, Element } from 'hast';

/**
 * Rehype plugin to transform <p> elements to <div> elements.
 * This prevents DOM nesting issues when inline citations (with HoverCard dropdowns)
 * are rendered inside paragraphs, as divs cannot be nested inside p elements.
 */
export const rehypeParagraphToDiv = (): ((tree: Root) => void) => {
  return (tree: Root) => {
    visit(tree, 'element', (node: Element) => {
      if (node.tagName === 'p') {
        node.tagName = 'div';
        node.properties = {
          ...node.properties,
          className: 'markdown-paragraph',
        };
      }
    });
  };
};
